/* Grondyke · Contact form
   1. Shows the order-number field only for topics flagged data-needs-order.
   2. On submit, prepends the chosen topic (and order number, business name, website when
      present) to contact[body] so the reply lands with context even if a mail client drops
      the extra contact[...] fields. Runs once per form; safe to re-run in the theme editor. */
(function () {
  function init(root) {
    if (root.dataset.gkReady) return;
    root.dataset.gkReady = '1';
    var form = root.querySelector('form');
    if (!form) return;
    var orderRow = root.querySelector('[data-gk-order]');
    var orderInput = root.querySelector('[data-gk-order-input]');
    var body = root.querySelector('[data-gk-body]');
    var radios = root.querySelectorAll('input[name="contact[topic]"]');

    function checkedTopic() {
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
      return null;
    }
    function syncOrder() {
      if (!orderRow) return;
      var t = checkedTopic();
      var show = !!(t && t.hasAttribute('data-needs-order'));
      orderRow.hidden = !show;
      if (!show && orderInput) orderInput.value = '';
    }
    for (var i = 0; i < radios.length; i++) radios[i].addEventListener('change', syncOrder);
    syncOrder();

    form.addEventListener('submit', function () {
      if (!body || body.dataset.gkPrefixed) return;
      var lines = [];
      var t = checkedTopic();
      if (t) lines.push('Topic: ' + t.value);
      if (orderInput && !orderRow.hidden && orderInput.value.trim()) lines.push('Order number: ' + orderInput.value.trim());
      var biz = root.querySelector('[data-gk-business]');
      if (biz && biz.value.trim()) lines.push('Business: ' + biz.value.trim());
      var site = root.querySelector('[data-gk-website]');
      if (site && site.value.trim()) lines.push('Website: ' + site.value.trim());
      if (lines.length) {
        body.value = lines.join('\n') + '\n\n' + body.value;
        body.dataset.gkPrefixed = '1';
      }
    });
  }
  function boot() {
    var roots = document.querySelectorAll('.gk-cf');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
